// extracted by mini-css-extract-plugin
export var cardcontainer = "sticky-timecard-module--cardcontainer--fMW5v";
export var datecontainer = "sticky-timecard-module--datecontainer--D5Qk1";
export var cardcontent = "sticky-timecard-module--cardcontent---D-p3";
export var cardtitle = "sticky-timecard-module--cardtitle--LjdFZ";
export var cardtext = "sticky-timecard-module--cardtext--TZONw";
export var centerGraphic = "sticky-timecard-module--centerGraphic--GHpcX";
export var sideGraphicRight = "sticky-timecard-module--sideGraphicRight--HYMFV";
export var sideGraphicLeft = "sticky-timecard-module--sideGraphicLeft--UajDC";
export var polileg = "sticky-timecard-module--polileg--zOneo";
export var viol = "sticky-timecard-module--viol--20qSg";
export var action = "sticky-timecard-module--action--mx-nU";
export var grassroots = "sticky-timecard-module--grassroots--XWBf-";
export var icon = "sticky-timecard-module--icon--H3sGE";